/* lcs-headings-contact.js — v2 (Contact H1 + demote decorativos + retry) */
(function () {
  var DEBUG = true;
  function log(){ if (DEBUG && window.console) try{ console.log.apply(console, arguments); }catch(_){ } }

  // Util: retag manteniendo clases/atributos/estilos
  function retagKeepStyles(el, tag){
    if (!el || el.tagName.toLowerCase() === tag) return el;
    var n = document.createElement(tag);
    // copiar atributos
    for (var i = 0; i < el.attributes.length; i++){
      var a = el.attributes[i];
      n.setAttribute(a.name, a.value);
    }
    // mover hijos
    while (el.firstChild) n.appendChild(el.firstChild);
    el.replaceWith(n);
    return n;
  }

  // Demover headings decorativos a presentacionales
  function demoteDecorative(){
    var deco = document.querySelectorAll('h2, h3');
    deco.forEach(function(h){
      var txt = (h.textContent || '').trim().toLowerCase();
      if (['cart','menu','quick shop'].indexOf(txt) >= 0){
        if (h.dataset.lcsDone) return;
        var d = document.createElement('div');
        d.setAttribute('role','presentation');
        d.setAttribute('aria-hidden','true');
        d.className = h.className;
        while (h.firstChild) d.appendChild(h.firstChild);
        h.replaceWith(d);
        h.dataset.lcsDone = '1';
        log('[Contact] Demote decorative:', txt);
      }
    });
  }

  // Promover “Contact Us” a H1
  function promoteContactH1(){
    // Buscar candidatos comunes del tema
    var nodes = document.querySelectorAll(
      'h1, h2, .s-header__title, .page-title, .section-title'
    );
    var candidate = null;
    nodes.forEach(function(n){
      var t = (n.textContent || '').trim().toLowerCase();
      if (!candidate && (t === 'contact' || t === 'contact us')){
        candidate = n;
      }
    });

    if (!candidate){
      log('[Contact] No heading candidate found yet.');
      return false; // para reintentar con observer
    }

    // Si ya es H1, solo marcar y salir
    if (candidate.tagName.toLowerCase() === 'h1'){
      candidate.id = candidate.id || 'page-title';
      candidate.setAttribute('aria-level','1');
      log('[Contact] Already H1:', candidate.textContent.trim());
      return true;
    }

    // Convertir a H1 manteniendo estilos
    var h1 = retagKeepStyles(candidate, 'h1');
    if (h1){
      h1.id = 'page-title';
      h1.setAttribute('aria-level','1');
      log('[Contact] Promoted to H1:', h1.textContent.trim());
      // Asegurar unicidad: degradar otros H1 dentro de main
      var main = document.querySelector('main') || document;
      var canon = h1;
      main.querySelectorAll('h1').forEach(function(h){
        if (h !== canon){
          retagKeepStyles(h, 'h2');
          log('[Contact] Extra H1 demoted → H2:', (h.textContent||'').trim());
        }
      });
      return true;
    }
    return false;
  }

  function run(){
    var ok = promoteContactH1();
    demoteDecorative();
    return ok;
  }

  // Lanzadores + reintentos (por si el tema inyecta tarde)
  function kickoff(){
    var ok = run();
    setTimeout(run, 200);   // retry corto
    setTimeout(run, 600);   // retry por carga diferida
  }

  if (document.readyState !== 'loading') kickoff();
  else document.addEventListener('DOMContentLoaded', kickoff);

  // Observer por mutaciones del tema
  var mo = new MutationObserver(function(muts){
    muts.forEach(function(m){
      if (m.addedNodes && m.addedNodes.length) run();
    });
  });
  mo.observe(document.documentElement, { childList:true, subtree:true });

  log('[Contact] Headings fix loaded.');
})();
